/**
 * Sets all text tracks of a video element to "hidden".
 *
 * @param {HTMLVideoElement} videoElement - The video element to set text tracks on.
 * @returns {void}
 */
export const setTextTracksToHidden = videoElement => {
  if (!videoElement?.textTracks?.[0]) return;
  for (const track of videoElement.textTracks) {
    track.mode = "hidden";
  }
};
